export default __webpack_public_path__ + "static/media/countdown.06000bcf.svg";